import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return this.checkLogin(route);
  }

  private checkLogin(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.waitingConfirmation()) {
      return true;
    } else if (!this.authService.isLoggedIn()) {
      const queryParams = route.queryParams;

      this.authService.logout();
      this.router.navigate(['/login'], { queryParams });
    }
  }
}

